export const routeLayoutEnum = {
    EMBED: "embed",
};
